// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .question-wrapper {
  border: 1px solid #ededee;
  background-color: #ffffff;
  min-height: 50px;
  padding: 15px 0;
  font-size: 14px;
}
:host .question-wrapper label {
  font-weight: 400;
  margin-bottom: 0;
  margin-top: 8px;
}
:host .question-hidden {
  visibility: hidden;
  height: 0px;
  padding: 0;
  min-height: 0px;
  max-height: 0px;
  width: 0px;
  min-width: 0px;
  max-width: 0px;
  margin: 0;
  border: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
